import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledArchivedMilestonesIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6679 16.4849V20.6023C18.6679 20.8556 18.5304 21.0871 18.2989 21.2319C17.2858 21.8614 14.4564 23.5909 12.9513 24.2928C12.3434 24.575 11.6198 24.5678 11.0192 24.2783C9.57193 23.5692 6.90898 21.8542 5.96102 21.2319C5.7367 21.0871 5.60645 20.8556 5.60645 20.6168V16.4921",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6679 16.4849V20.6023C18.6679 20.8556 18.5304 21.0871 18.2989 21.2319C17.2858 21.8614 14.4564 23.5909 12.9513 24.2928C12.3434 24.575 11.6198 24.5678 11.0192 24.2783C9.57193 23.5692 6.90898 21.8542 5.96102 21.2319C5.7367 21.0871 5.60645 20.8556 5.60645 20.6168V16.4921",
			stroke: "#1F3B44",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.60645 6.40481V2.22224C5.60645 0.919704 6.60505 0.5 7.84246 0.5H16.4319C17.6693 0.5 18.6679 0.919704 18.6679 2.22224V6.41204",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.60645 6.40481V2.22224C5.60645 0.919704 6.60505 0.5 7.84246 0.5H16.4319C17.6693 0.5 18.6679 0.919704 18.6679 2.22224V6.41204",
			stroke: "#1F3B44",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1408 19.5764C16.6369 19.5764 20.2816 15.9316 20.2816 11.4356C20.2816 6.93951 16.6369 3.29474 12.1408 3.29474C7.64477 3.29474 4 6.93951 4 11.4356C4 15.9316 7.64477 19.5764 12.1408 19.5764Z",
			fill: "white",
			stroke: "#1F3B44",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8553 7.37793C11.9451 7.10154 12.3361 7.10154 12.4259 7.37793L13.1958 9.74744C13.236 9.87104 13.3512 9.95473 13.4812 9.95473H15.9726C16.2632 9.95473 16.3841 10.3266 16.1489 10.4974L14.1333 11.9619C14.0282 12.0383 13.9842 12.1737 14.0243 12.2973L14.7942 14.6668C14.884 14.9432 14.5677 15.173 14.3326 15.0022L12.317 13.5378C12.2118 13.4614 12.0694 13.4614 11.9643 13.5378L9.94867 15.0022C9.71355 15.173 9.39721 14.9432 9.48702 14.6668L10.2569 12.2973C10.2971 12.1737 10.2531 12.0383 10.1479 11.9619L8.13231 10.4974C7.8972 10.3266 8.01803 9.95473 8.30865 9.95473H10.8001C10.9301 9.95473 11.0452 9.87104 11.0854 9.74744L11.8553 7.37793Z",
			fill: "#4B7987",
			stroke: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledArchivedMilestonesIcon);
const Memo = memo(ForwardRef);
export default Memo;
